exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".page-content {\n  padding: 40px;\n  float: left; }\n  .page-content h1 {\n    border-bottom: 1px solid #91b3f3;\n    float: left;\n    padding-bottom: 10px;\n    padding-right: 30px;\n    color: #00507f; }\n  .page-content p {\n    clear: both;\n    padding: 20px;\n    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26); }\n\n.breadcrumb-container {\n  padding: 5px 15px 10px;\n  display: -ms-flexbox !important;\n  display: flex !important; }\n  .breadcrumb-container .icon-home {\n    padding-top: 2px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/page-view/page-view.component.scss
// module id = 799
// module chunks = 6